export const environment = {
  production: true,
  // serverUrl : 'https://192.168.3.6:8080',
  // serverUrl : 'http://192.168.3.22'
  // serverUrl: 'http://13.228.44.88'
  // serverUrl: "https://springboot.cyberstar.com.tw"
  // serverUrl:"http://localhost"
  serverUrl : location.protocol + "//" + location.hostname + ":" + location.port
};
